import { put } from 'redux-saga/effects';
import { relatedVideosResetAction } from '../related-videos/actions';
import { videoCommentsResetAction } from '../video-comments/actions';
import { fetchVideoApi } from 'common/api/videos';
import { getUserEffect } from 'common/sagas/effects/get-user';
import {
  videoBoxErrorAction,
  videoBoxSuccessAction,
  updateVideoUploaderInfoAction,
  updateVideoResponsibleUserAction,
} from '../actions';
import i18next from 'i18next';

export function* fetchVideoEffect({ payload }) {
  yield put(relatedVideosResetAction());
  yield put(videoCommentsResetAction());
  try {
    const response = yield fetchVideoApi(payload.videoId);
    try {
      if (response.uploaderUserId !== -1) {
        const uploader = yield* getUserEffect(response.uploaderUserId);
        yield put(updateVideoUploaderInfoAction(uploader));
      }

      if (response.responsibleUserId !== -1) {
        const user = yield* getUserEffect(response.responsibleUserId);
        yield put(updateVideoResponsibleUserAction(user));
      }
    } catch (error) {
      // the user-service can't find users in edge-cases
    }

    yield put(videoBoxSuccessAction(response));
  } catch (error) {
    yield put(videoBoxErrorAction(i18next.t('video_not_found')));
  }
}
